export default __webpack_public_path__ + "static/media/no-flights.32e46ef7.png";